import React, { useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import _ from 'lodash';

import { Grid, Button, Icon, Segment, Image } from 'semantic-ui-react';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import Question from './question.jsx';
import Result from './result.jsx';
import IdentityService from 'services/identity.service';
import mixpanel from 'mixpanel-browser';

import styles from '../App.module.scss';


function Quiz({ quiz }) {
  const { url } = useRouteMatch();
  const [current, setCurrent] = useState(0);
  const [result, setResult] = useState({
    answers: {},
    showResult: false
  });

  useEffect(() => {
    const visitor = IdentityService.getFingerprint();
    const type = url === '/manager' ? 'manager' : 'rep';
    
    mixpanel.track("Quiz Started", {
      "type": type,
      "visitor": visitor
    });
  }, []);

  const handleNext = () => {
    const next = current + 1;
    if (next >= quiz.questions.length) {
      return false;
    }

    setCurrent(next);
  }

  const handlePrevious = () => {
    const previous = current - 1;
    if (previous < 0) {
      return false;
    }

    setCurrent(previous);
  }

  const onQuestionChange = (question, value) => {
    var updated = {
      ...result,
      answers: {
        ...result.answers,
        [question]: value
      }
    };

    setResult({
      ...updated,
      showResult: isComplete(updated)
    });

    handleNext();
  }

  const answered = _.get(result, `answers.${current}`, null) != null;

  const isComplete = (result) => {
    return Object.keys(result.answers).length === 5;
  }

  return (
    <>
      {result.showResult &&
        <Grid container centered>
          <Result quiz={quiz} value={result} />
        </Grid>
      }
      {!result.showResult &&
        <div className={styles.questions}>
          <Grid>
            <Grid.Column mobile={16} tablet={11} computer={11} verticalAlign='middle' stretched>
              <Grid container centered >
                <Grid.Column width={1} only='tablet computer' textAlign='center' verticalAlign='middle'>
                  <Button icon onClick={handlePrevious} className={styles.arrow}>
                    <Icon name='chevron left' size='big'/>
                  </Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={10} computer={10}>
                  <Segment basic padded>
                    <Carousel
                      draggable={false}
                      value={current}
                    >
                      {quiz.questions.map((question, index) => {
                        return (
                          <Question
                            key={question.index}
                            index={question.index}
                            title={question.title}
                            options={question.options}
                            value={_.get(result, `answers.${question.index}`, false)}
                            onChange={onQuestionChange}
                          />
                        );
                      })}
                    </Carousel>
                  </Segment>
                </Grid.Column>
                <Grid.Column width={1} only='tablet computer' textAlign='center' verticalAlign='middle'>
                  <Button icon onClick={handleNext} className={styles.arrow} disabled={!answered}>
                    <Icon name='chevron right' size='big'/>
                  </Button>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={5} computer={5} textAlign='center' stretched>
              <Image src="/images/poster.jpg" />
            </Grid.Column>
          </Grid>
        </div>
      }
    </>
  );
}

export default Quiz;
